(() => {
  if (!customElements.get('makeup-gallery')) customElements.define('makeup-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.mpe-slide')];
      this.thumbs = [...this.querySelectorAll('[data-makeup-slide]')];
      this.index = Number(this.dataset.initial) || 0;
      this.media = JSON.parse(this.querySelector('[data-makeup-media-map]')?.textContent || '{}');
      this.dialog = this.querySelector('dialog');
      this.setActiveMedia(this.media[this.dataset.variant]);
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-makeup-slide]');
        if (thumb) this.show(Number(thumb.dataset.makeupSlide));
        if (event.target.closest('[data-makeup-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-makeup-next]')) this.show(this.index + 1);
        const zoom = event.target.closest('[data-makeup-zoom]');
        if (zoom && this.dialog) { this.dialog.querySelector('img').src = zoom.dataset.makeupZoom; this.dialog.showModal(); }
        if (event.target.closest('[data-makeup-close]') || event.target === this.dialog) this.dialog?.close();
      });
      this.addEventListener('keydown', event => {
        if (this.dialog?.open) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
      });
      this.querySelector('.mpe-stage')?.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; this.touchY = event.changedTouches[0].clientY; }, {passive:true});
      this.querySelector('.mpe-stage')?.addEventListener('touchend', event => {
        const dx = event.changedTouches[0].clientX - this.touchX, dy = event.changedTouches[0].clientY - this.touchY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
      }, {passive:true});
      this.closest('.bagspot-makeup-product')?.addEventListener('change', event => {
        const picker = event.target.closest('variant-selects');
        if (!picker) return;
        const sets = [...picker.querySelectorAll('fieldset,select')];
        const values = sets.map(set => set.tagName === 'SELECT' ? set.value : set.querySelector('input:checked')?.value);
        const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
        const variant = variants.find(v => v.options.every((value, index) => value === values[index]));
        if (variant) this.setActiveMedia(this.media[variant.id]);
        const stock = this.closest('.bagspot-makeup-product')?.querySelector('.mpe-stock');
        if (stock) { stock.textContent = variant?.available ? stock.dataset.inStock : stock.dataset.outOfStock; stock.classList.toggle('mpe-stock--out', !variant?.available); }
        
      });
    }
    setActiveMedia(id) { const index = this.slides.findIndex(slide => slide.dataset.imageId === id); if (index >= 0) this.show(index); }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; if (i !== this.index) slide.querySelectorAll('video').forEach(video => video.pause()); });
      this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === this.index)));
      const count = this.querySelector('[data-makeup-count]'); if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
  });
  function sticky(section) {
    if (section.dataset.makeupStickyReady) return;
    section.dataset.makeupStickyReady = 'true';
    const mainButton = section.querySelector('.product-form__submit');
    const form = mainButton?.form;
    if (!mainButton || !form) return;
    const bar = document.createElement('div'); bar.className = 'mpe-mobile-cart';
    const price = document.createElement('span'); price.className = 'mpe-sticky-price';
    const button = document.createElement('button'); button.type = 'submit'; button.setAttribute('form', form.getAttribute('id'));
    bar.append(price, button); section.append(bar);
    const sync = () => { price.textContent = section.querySelector('.priceSingle .price-item')?.textContent || ''; button.disabled = mainButton.disabled; button.textContent = mainButton.textContent.trim(); };
    sync();
    new MutationObserver(sync).observe(section.querySelector('.priceSingle') || mainButton, {childList:true,subtree:true,characterData:true});
    new MutationObserver(sync).observe(mainButton, {attributes:true,attributeFilter:['disabled'],childList:true,subtree:true,characterData:true});
    const updateVisibility = () => { const toolbar = document.querySelector('.mbtoolbar'); const height = toolbar && getComputedStyle(toolbar).display !== 'none' ? toolbar.getBoundingClientRect().height : 0; section.style.setProperty('--makeup-toolbar-height', height + 'px'); bar.classList.toggle('is-visible', mainButton.getBoundingClientRect().bottom <= 0); };
    new IntersectionObserver(updateVisibility, {threshold:0}).observe(mainButton);
    let queued = false;
    const onScroll = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; updateVisibility(); }); };
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
  }
  const boot = () => document.querySelectorAll('.bagspot-makeup-product').forEach(section => { sticky(section); if (!section.dataset.makeupFitReady) { section.dataset.makeupFitReady = 'true'; section.addEventListener('click', event => { if (event.target.closest('.mpe-fit-link')) { const fit = document.querySelector('#makeup-fit'); if (fit) fit.open = true; } }); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
